import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const EditButton = (props) => <Button startIcon={<EditIcon />} {...props} />;

export default EditButton;
